<template>
  <div :class="`col-span-6 mb-1 ${this.showOptions?'h-56 min-h-full':''}`">
    <label for="combobox" class="block text-sm font-medium text-gray-700">{{field.label}}</label>
    <div class="relative mt-1">
      <input id="combobox"
        type="text"
        class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-12 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
        role="combobox"
        autocomplete="off"
        aria-controls="options"
        aria-expanded="false"
        v-model="queryValue"
        v-on:input="filtered($event.target.value)">
      <button
        type="button"
        class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
        v-on:click="toggleShowOptions"
        >
        <!-- Heroicon name: solid/selector -->
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>

      <ul v-if="showOptions" class="absolute z-10 mt-1 max-h-48 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" id="options" role="listbox">
        <template v-for="item in itemsFiltered">
          <li v-on:click="selectItem(item)" :key="item[field.options_key]" class="relative cursor-default select-none py-1 pl-3 pr-9 text-gray-900" :id="item.id" role="option" tabindex="-1">
            <span class="block truncate">{{item[field.options_label]}}</span>
            <span v-if="selected===item" class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'search-option-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.fetchOptions()
  },
  methods: {
    async fetchOptions(){
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          key: this.field.options_key,
          id: this.$route.params.record,
          ...this.$store.state.data,
          ...this.formdata,
          ...this.params,
          ...this.dependentdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.items = response.data
      this.filtered('')
      this.showOptions = false
    },
    filtered(query) {
      this.queryValue = query
      this.showOptions = true
      this.itemsFiltered = query === ''
      ? this.items
      : this.items.filter((item) => {
          return item.label.toLowerCase().includes(this.queryValue.toLowerCase())
        })
    },
    toggleShowOptions() {
      this.showOptions = !this.showOptions;
    },
    selectItem(item) {
      this.selected = item
      this.queryValue = item[this.field.options_label]
      this.showOptions = false
      this.$parent.updateValue(this.field.key, item[this.field.options_value])
    }
  },
  data(){
    return {
      showOptions: false,
      selected: undefined,
      queryValue: '',
      itemsFiltered: [],
      items: []
    }

  }
}
</script>
